// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.gridPageSizeHeader {
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
}

.gridPageSize {
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--default-FontWeight);
  align-items: center;
  width: auto;
  height: 41px;
}

.gridPageSize .dropdownctrl {
  width: 70px;
}

.gridPageSize .dropdownctrl .MuiInputBase-root .MuiSelect-icon {
  height: 100%;
  top: 0px;
}

.gridPageSize .dropdown .MuiFormLabel-root {
  display: none;
}

.gridPageSize .MuiFormControl-root.dropdown .MuiFilledInput-input {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.gridPageSize
  .MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {
  background: #ffffff;
}

.gridPageRefresh {
  width: 21.32px;
  height: 21.33px;
  cursor: pointer;
}

.gridPageSizeHeader .gridRefreshDiv p {
  margin: 0px;
}

.gridPageSizeHeader .gridRefreshDiv {
  display: grid;
  grid-template-columns: min-content min-content;
  gap: 10px;
  align-items: center;
  margin: -110px 0px 0px 0px;
}

.gridPageRefresh,
.gridPageSizeHeader .columnFilterSection {
  cursor: pointer;
}

.gridPageSizeHeader .gridRefreshDiv p {
  margin: 0px;
}

.gridPageSizeHeader .gridRefreshDiv,
.gridPageSizeHeader .columnFilterSection {
  display: grid;
  gap: 10px;
  align-items: center;
}

.gridPageSizeHeader .gridRefreshDiv {
  grid-template-columns: min-content min-content;
  margin: -110px 0px 0px 0px;
}

.gridPageSizeHeader .columnFilterSection {
  grid-template-columns: auto auto;
  margin: 0px;
}

.gridPageSizeHeader .gridRefreshDiv .refreshedDateTime {
  font-style: italic;
  height: fit-content;
  white-space: nowrap;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  color: var(--countTitleFontColor);
  font-weight: var(--default-FontWeight);
  line-height: 21px;
}

@media (min-width: 1000px) and (max-width: 1600px) {
  .gridPageSizeHeader .gridRefreshDiv {
    margin: -105px 0px 0px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/gridPageSize/GridPageSize.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,oCAAoC;EACpC,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,iCAAiC;EACjC,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.gridPageSizeHeader {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: space-between;\n}\n\n.gridPageSize {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--default-FontWeight);\n  align-items: center;\n  width: auto;\n  height: 41px;\n}\n\n.gridPageSize .dropdownctrl {\n  width: 70px;\n}\n\n.gridPageSize .dropdownctrl .MuiInputBase-root .MuiSelect-icon {\n  height: 100%;\n  top: 0px;\n}\n\n.gridPageSize .dropdown .MuiFormLabel-root {\n  display: none;\n}\n\n.gridPageSize .MuiFormControl-root.dropdown .MuiFilledInput-input {\n  background: #ffffff;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n}\n\n.gridPageSize\n  .MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiInputBase-marginDense.MuiFilledInput-marginDense {\n  background: #ffffff;\n}\n\n.gridPageRefresh {\n  width: 21.32px;\n  height: 21.33px;\n  cursor: pointer;\n}\n\n.gridPageSizeHeader .gridRefreshDiv p {\n  margin: 0px;\n}\n\n.gridPageSizeHeader .gridRefreshDiv {\n  display: grid;\n  grid-template-columns: min-content min-content;\n  gap: 10px;\n  align-items: center;\n  margin: -110px 0px 0px 0px;\n}\n\n.gridPageRefresh,\n.gridPageSizeHeader .columnFilterSection {\n  cursor: pointer;\n}\n\n.gridPageSizeHeader .gridRefreshDiv p {\n  margin: 0px;\n}\n\n.gridPageSizeHeader .gridRefreshDiv,\n.gridPageSizeHeader .columnFilterSection {\n  display: grid;\n  gap: 10px;\n  align-items: center;\n}\n\n.gridPageSizeHeader .gridRefreshDiv {\n  grid-template-columns: min-content min-content;\n  margin: -110px 0px 0px 0px;\n}\n\n.gridPageSizeHeader .columnFilterSection {\n  grid-template-columns: auto auto;\n  margin: 0px;\n}\n\n.gridPageSizeHeader .gridRefreshDiv .refreshedDateTime {\n  font-style: italic;\n  height: fit-content;\n  white-space: nowrap;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  color: var(--countTitleFontColor);\n  font-weight: var(--default-FontWeight);\n  line-height: 21px;\n}\n\n@media (min-width: 1000px) and (max-width: 1600px) {\n  .gridPageSizeHeader .gridRefreshDiv {\n    margin: -105px 0px 0px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
